import { handleNotificationEmailLink } from '@ruta/shared';
export function openNotificationEmailAction(actionLink: string | undefined): boolean {
  return handleNotificationEmailLink(actionLink, url => window.location.assign(url));
}
